module.exports = __webpack_public_path__ + "img/typing_indicator.dc349ebc.gif";